import { toast, ToastOptions } from 'react-toastify'

export const notify = (type: string, msg: string, customId: string): {} => {
  const options: ToastOptions<{}> = {
    toastId: customId,
    position: 'top-center',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'dark',
  }
  switch (type) {
    case 'error':
      return toast.error(msg, options)
    case 'success':
      return toast.success(msg, options)
    case 'warn':
      return toast.warn(msg, options)
    default:
      return toast(msg, options)
  }
}
